import { render, staticRenderFns } from "./vina-cobos.vue?vue&type=template&id=3d20a9a0&scoped=true"
import script from "./vina-cobos.vue?vue&type=script&lang=js"
export * from "./vina-cobos.vue?vue&type=script&lang=js"
import style0 from "./vina-cobos.vue?vue&type=style&index=0&id=3d20a9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20a9a0",
  null
  
)

export default component.exports